import logger from './logger';

// Responsible for ensuring channel subscribe command is confirmed, retrying until confirmation is received.
// Internal class, not intended for direct user manipulation.

export default class SubscriptionGuarantor
{
    readonly subscriptions: any;
    pendingSubscriptions: any[];
    retryTimeout: any;

    /**
     * Constructor
     */
    constructor(subscriptions: any)
    {
        this.subscriptions        = subscriptions;
        this.pendingSubscriptions = [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    guarantee(subscription: any): void
    {
        if (this.pendingSubscriptions.indexOf(subscription) === -1)
        {
            logger.log(`SubscriptionGuarantor guaranteeing ${subscription.identifier}`);
            this.pendingSubscriptions.push(subscription);
        }
        else
        {
            logger.log(`SubscriptionGuarantor already guaranteeing ${subscription.identifier}`);
        }
        this.startGuaranteeing();
    }

    forget(subscription: any): void
    {
        logger.log(`SubscriptionGuarantor forgetting ${subscription.identifier}`);
        this.pendingSubscriptions = (this.pendingSubscriptions.filter((s) => s !== subscription));
    }

    startGuaranteeing(): void
    {
        this.stopGuaranteeing();
        this.retrySubscribing();
    }

    stopGuaranteeing(): void
    {
        clearTimeout(this.retryTimeout);
    }

    retrySubscribing(): void
    {
        this.retryTimeout = setTimeout(() =>
            {
                if (this.subscriptions && typeof (this.subscriptions.subscribe) === 'function')
                {
                    this.pendingSubscriptions.map((subscription) =>
                    {
                        logger.log(`SubscriptionGuarantor resubscribing ${subscription.identifier}`);
                        this.subscriptions.subscribe(subscription);
                    });
                }
            }
            , 500);
    }
}
